module.exports = __webpack_public_path__ + "d2a172b65b86fa6f1711d440e1a4738b.png";